import React from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth, routeAfterAuth } from "../lib/auth";
import { WaiverForm } from "../components/WaiverForm";
import { BrandLogo } from "../components/Navbar";

export default function WaiverPage() {
  const { user, loading, refresh } = useAuth();
  const nav = useNavigate();
  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  const submit = async (b) => (await api.post("/waiver/sign", b)).data;
  async function done() {
    await refresh();
    nav(sessionStorage.getItem("lif_after_waiver") || routeAfterAuth(user), { replace: true });
    sessionStorage.removeItem("lif_after_waiver");
  }
  return (
    <div className="min-h-screen bg-[var(--bg)] flex items-center justify-center px-5 py-12" data-testid="waiver-page">
      <div className="w-full max-w-lg bg-white border border-[var(--line)] rounded-3xl p-7 md:p-10">
        <div className="mb-6"><BrandLogo /></div>
        <h1 className="font-serif font-light text-4xl mb-2">One quick signature</h1>
        <p className="text-sm text-[var(--muted)] mb-8">Before you upload photos or post anything, everyone signs this short release. You only do it once.</p>
        {user.media_waiver_signed ? <button onClick={done} className="btn-gold w-full" data-testid="waiver-already">You've already signed. Continue</button> : <WaiverForm submit={submit} onSigned={done} />}
      </div>
    </div>
  );
}

const FREE = ["/waiver", "/agreements/sign", "/logout", "/login", "/signup", "/account/orders", "/market", "/live/gift-thanks", "/call-center", "/q/", "/gift-cards", "/meet/", "/audit/", "/join-vendor", "/contest", "/careers"];

// Sends any signed-in user who hasn't signed the current release to /waiver first.
export function WaiverGate({ children }) {
  const { user } = useAuth();
  const { pathname: path, search } = useLocation();
  if (user?.role === "applicant" && !path.startsWith("/careers") && !["/logout", "/login", "/signup"].some((p) => path.startsWith(p))) return <Navigate to="/careers/me" replace />;
  if (user && !user.media_waiver_signed && !FREE.some((p) => path.startsWith(p))) {
    sessionStorage.setItem("lif_after_waiver", path + search);
    return <Navigate to="/waiver" replace />;
  }
  return children;
}
